module.exports = __webpack_public_path__ + "media/print/images-per-page_4-f4017c01.png";